<template>
  <section id="dashboard-ecommerce">
    <div v-if="closeSistemInformation.targetClose" class="col-12 border border-1 p-1 rounded text-center bg-light-danger mb-1">
      <div class="text-danger font-weight-bold text-uppercase">Perhatian !</div>
      <span>Sistem Inventarisasi BMD PERALATAN DAN MESIN (KIB B) ditutup pada <b>{{ closeSistemInformation.targetClose }} </b></span>
    </div>
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-form class="needs-validation mb-1" @submit.prevent="submitFilter">
          <b-row>
            <b-col cols="3">
              <b-form-group label="Tahun Pelaksanaan" label-for="tahunFilter">
                <b-form-select id="tahunFilter" v-model="tahunFilter" :options="dataTahunPelaksanaan" />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Wilayah" label-for="wilayahFilter">
                <b-form-select id="wilayahFilter" v-model="wilayahFilter" :options="dataWilayah"
                  :disabled="!$can('Filter', 'b-dashboard') || !isShowPdUpd" @change="changeWilayah" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="PD/UKPD" label-for="pdUpdFilter">
                <v-select id="kolok" v-model="pdUpdFilterValue" label="text" :options="dataPdUpd" :disabled="!$can('Filter', 'b-dashboard') &&
                  !$can('Filter-PdUpd', 'b-dashboard')
                  " @input="inputPdUpd" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" align="right">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="sm" type="submit">
                Filter
              </b-button>
            </b-col>
          </b-row>
        </b-form>

        <b-card class="card-statistics">
          <b-card-body>
            <b-alert v-if="isShowWarning" variant="warning" show class="text-center">
              <div class="alert-body">
                <span><strong>Peringatan</strong></span>
                <feather-icon icon="InfoIcon" class="mr-50" />
                <p><strong>Filter PD/UKPD</strong> harus dipilih</p>
              </div>
            </b-alert>
            <b-overlay :show="isLoadingChart" variant="light" opacity="0.85" blur="2px" rounded="sm">
              <b-row class="match-height mb-5">
                <b-col md="4" cols="12">
                  <div class="pie-text text-center">
                    <h3 class="font-weight-bolder">
                      {{ kalkulasiBmd[0].value }}
                    </h3>
                    <span class="font-weight-bold">Total</span>
                  </div>
                  <app-echart-doughnut :series="series" />
                </b-col>
                <b-col md="8" cols="12">
                  <b-row>
                    <b-col v-for="(item, i) of kalkulasiBmd" :key="i" xl="6" sm="6" :class="item.customClass">
                      <b-media no-body>
                        <b-media-aside class="mr-2">
                          <b-avatar size="48" :variant="item.color">
                            <feather-icon size="24" :icon="item.icon" />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="font-weight-bolder mb-0">
                            {{ item.value }}
                          </h4>
                          <b-card-text class="font-small-3 mb-0">
                            {{ item.label }}
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card-body>
        </b-card>

        <!-- <b-card no-body>
          <b-card-header>
            <div>
              <b-card-title class="mb-1">
                Capaian Inventarisasi Per Bulan
              </b-card-title>
            </div>
          </b-card-header>

          <b-card-body>
            <b-overlay
              :show="isLoadingChart"
              variant="light"
              opacity="0.85"
              blur="2px"
              rounded="sm"
            >
              <app-echart-line :option-data="dataChart.options" />
            </b-overlay>
          </b-card-body>
        </b-card> -->
      </b-col>
    </b-row>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="mb-1">
          Tabel Monitoring
        </b-card-title>
        <div>Last Sync At: {{ parserValue("dateTime", lastSyncAt) }}</div>
      </b-card-header>
      <b-card-body>
        <b-alert v-if="isShowWarning" variant="warning" show class="text-center">
          <div class="alert-body">
            <span><strong>Peringatan</strong></span>
            <feather-icon icon="InfoIcon" class="mr-50" />
            <p><strong>Filter PD/UKPD</strong> harus dipilih</p>
          </div>
        </b-alert>
        <Table :columns="columns" :rows="rows" :is-loading="isShowTable" :total-records="totalRecords"
          :per-page="parseInt(perPage)" :handle-change-page="changePage" :search="searchQuery"
          :handle-search="keyUpSearch" @emitPerPage="(value) => {
            perPage = value;
            inputPerPage()
          }
            " @emitSearch="(value) => {
    searchQuery = value;
    keyUpSearch()
  }">
          <template slot="component-between-search">
            <b-button v-if="!isShowWarning" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
              @click="clickPrint">
              Print
            </b-button>
          </template>
        </Table>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BButton,
  BForm,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut.vue'
import apiDashboard from '@/composables/b/dashboard'
import apiMaster from '@/composables/master/masterBRef'
import Table from '@/components/table/CommonTable.vue'
import {
  generateYears, startYear, intThousand, showError,
} from '@/libs/helper'

import { parserValue, closeSistemKibB } from '@/libs/helper'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g
    const lastSyncAt = ref();
    const year = moment().format('YYYY')
    const isLoadingChart = ref(false)
    const isShowWarning = ref(false)
    const isShowPdUpd = ref(true)

    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const wilayahFilter = ref($route.query.wilayah || '')
    const series = ref([
      {
        name: '',
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: [
          { value: 0, name: 'SELESAI INVENTARISASI' },
          { value: 0, name: 'SEDANG INVENTARISASI' },
          { value: 0, name: 'BELUM INVENTARISASI' },
        ],
      },
    ])
    const tahunFilter = ref(year)
    const isShowTable = ref(false)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (['D', 'F', 'A'].includes(cookiesJenisAkun.value)) {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const rows = ref([])

    const dataWilayah = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    let tempListYear = [{
      text: '--Pilih Salah Satu--',
      value: '',
    }]
    if (g.$cookies.get('listTahun')) {
      const listTahun = JSON.parse(g.$cookies.get('listTahun'))
      tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_rekon, text: item.tahun_pelaksanaan }))]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    } else {
      tempListYear = [...tempListYear, ...generateYears(startYear, year)]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    }
    const dataTahunPelaksanaan = ref(tempListYear)

    const kalkulasiBmd = ref([
      {
        label: 'JUMLAH BMD',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-primary',
        customClass: 'mb-2',
      },
      {
        label: 'BELUM INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-danger',
        customClass: 'mb-2',
      },
      {
        label: 'SEDANG INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-warning',
        customClass: 'mb-2',
      },
      {
        label: 'SELESAI INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-success',
        customClass: 'mb-2',
      },
    ])

    watch(dataPdUpd, () => {
      if ($route.query['pd-upd'] && dataPdUpd.value.length > 1) {
        const index = dataPdUpd.value.findIndex(item => item.value == $route.query['pd-upd'])
        pdUpdFilterValue.value = dataPdUpd.value[index]
      }
    })

    const getData = async () => {
      isShowWarning.value = !pdUpdFilter.value
      try {
        isLoadingChart.value = true
        const {
          data: {
            total_bmd: totalBmd,
            // total_bmd_belum_tercatat
            total_selesai: selesaiInventarisasi,
            // total_selesai_belum_tercatat
            total_validasi_p3b: totalValidasiP3b,
            // total_validasi_p3b_belum_tercatat
            total_belum_invent: belumInventarisasi,
            total_dikembalikan: totalDikembalikan,
            // total_dikembalikan_belum_tercatat
          },
        } = await apiDashboard.getDetailSummary(g, {
          filter_kolok: pdUpdFilter.value || 'semua',
          filter_wilayah: wilayahFilter.value,
          filter_tahun: tahunFilter.value,
        })

        kalkulasiBmd.value[0].value = new Intl.NumberFormat('id-ID').format(totalBmd)
        kalkulasiBmd.value[1].value = new Intl.NumberFormat('id-ID').format(belumInventarisasi)
        kalkulasiBmd.value[2].value = new Intl.NumberFormat('id-ID').format(parseInt(totalValidasiP3b, 10) + parseInt(totalDikembalikan, 10))
        kalkulasiBmd.value[3].value = new Intl.NumberFormat('id-ID').format(selesaiInventarisasi)
        series.value[0].data[0].value = selesaiInventarisasi
        series.value[0].data[1].value = parseInt(totalValidasiP3b, 10) + parseInt(totalDikembalikan, 10)
        series.value[0].data[2].value = belumInventarisasi
      } catch (error) {
        console.log(error)
      }

      isLoadingChart.value = false
    }

    const dataSummary = async () => {
      if (pdUpdFilter.value) {
        isShowTable.value = true

        const params = {
          filter_kolok: pdUpdFilter.value,
          limit: perPage.value,
          start: (currentPage.value - 1) * perPage.value,
          filter_wilayah: wilayahFilter.value,
          cari: searchQuery.value,
        }
        const { code, rows: list, totalRows, last_sync_at } = await apiDashboard.getSummaryPerKolok(g, params)

        if (code == 200) {
          rows.value = list.map(item => {
            const belumSensus = item.belum_sensus || 0
            const belumInventarisasiPercentage = `${new Intl.NumberFormat('id-ID', {
              maximumFractionDigits: 2,
            }).format((belumSensus / item.total_bmd) * 100)}%`
            return {
              pendamping: item.pendamping,
              nalok: item.nalok,
              jumlahRegister: new Intl.NumberFormat('id-ID').format(item.total_bmd),
              belumInventarisasi: new Intl.NumberFormat('id-ID').format(belumSensus),
              belumInventarisasiPercentage,
              draft: new Intl.NumberFormat('id-ID').format(item.draft),
              draftPercentage: `${new Intl.NumberFormat('id-ID', {
                maximumFractionDigits: 2,
              }).format((item.draft / item.total_bmd) * 100)}%`,
              menungguValidasiP3b: new Intl.NumberFormat('id-ID').format(item.menunggu_validasi_p3b),
              menungguValidasiP3bPercentage: `${new Intl.NumberFormat('id-ID', {
                maximumFractionDigits: 2,
              }).format((item.menunggu_validasi_p3b / item.total_bmd) * 100)}%`,
              dikembalikanP3b: new Intl.NumberFormat('id-ID').format(item.dikembalikan_p3b),
              dikembalikanP3bPercentage: `${new Intl.NumberFormat('id-ID', {
                maximumFractionDigits: 2,
              }).format((item.dikembalikan_p3b / item.total_bmd) * 100)}%`,
              selesaiInventarisasi: new Intl.NumberFormat('id-ID').format(item.selesai_sensus),
              selesaiInventarisasiPercentage: `${new Intl.NumberFormat('id-ID', {
                maximumFractionDigits: 2,
              }).format((item.selesai_sensus / item.total_bmd) * 100)}%`,
            }
          })
          totalRecords.value = totalRows;
          lastSyncAt.value = last_sync_at;
        } else {
          rows.value = []
          totalRecords.value = 0
        }

        isShowTable.value = false
      }
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&tahun=${tahunFilter.value}&pd-upd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      getData()
      // datatable();
      dataSummary()
    }

    const getWilayah = async () => {
      const resWilayah = await apiMaster.getWilayah(g)

      dataWilayah.value = [{ text: '-- Semua --', value: '' }, ...resWilayah.rows]
    }

    const getPdUpd = async (searchPdUpd = '') => {
      isShowPdUpd.value = false
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await apiMaster.getKolokDs(g, params)
      dataPdUpd.value = [{ text: '-- Semua --', value: '' }, ...resPdUpd.rows]
      isShowPdUpd.value = true
    }

    const changePage = page => {
      currentPage.value = page
      dataSummary()
      // datatable();
    }

    const keyUpSearch = () => {
      currentPage.value = 1
      dataSummary()
    }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const inputPerPage = () => {
      currentPage.value = 1
      dataSummary()
    }

    const clickPrint = async () => {
      try {
        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna-b/analytic/dashboard?filter_kolok=${pdUpdFilter.value}`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }
    }

    const numThousand = value => intThousand(value)

    // datatable();
    getPdUpd()
    dataSummary()
    getData()
    getWilayah()

    const closeSistemInformation = ref({});
    setInterval(() => {
      closeSistemInformation.value = closeSistemKibB();
    }, 1000);
    return {
      isShowWarning,
      perPage,
      perPageOptions,
      searchQuery,
      rows,
      sortBy,
      isSortDirDesc,
      totalRecords,
      currentPage,
      isLoadingChart,
      isShowTable,
      pdUpdFilterValue,
      pdUpdFilter,
      wilayahFilter,
      tahunFilter,
      kalkulasiBmd,
      series,
      dataWilayah,
      dataTahunPelaksanaan,
      dataPdUpd,
      changeWilayah,
      inputPdUpd,
      submitFilter,
      inputPerPage,
      keyUpSearch,
      changePage,
      clickPrint,
      numThousand,
      isShowPdUpd,
      lastSyncAt,
      parserValue,
      closeSistemInformation
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
    AppEchartDoughnut,
    Table,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columns: [
        {
          label: 'Pendamping',
          field: 'pendamping',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'PD/UKPD',
          field: 'nalok',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'JUMLAH REGISTER',
          field: 'jumlahRegister',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'BELUM INVENTARISASI',
          field: 'belumInventarisasi',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: '%',
          field: 'belumInventarisasiPercentage',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Draft',
          field: 'draft',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: '%',
          field: 'draftPercentage',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Menunggu Validasi P3B',
          field: 'menungguValidasiP3b',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: '%',
          field: 'menungguValidasiP3bPercentage',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Dikembalikan P3B',
          field: 'dikembalikanP3b',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: '%',
          field: 'dikembalikanP3bPercentage',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Selesai Inventarisasi',
          field: 'selesaiInventarisasi',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: '%',
          field: 'selesaiInventarisasiPercentage',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
      tableColumns: [
        'pendamping',
        { key: 'nalok', label: 'PD/UKPD' },
        { key: 'jumlahRegister', label: 'JUMLAH REGISTER' },
        { key: 'belumInventarisasi', label: 'BELUM INVENTARISASI' },
        { key: 'belumInventarisasiPercentage', label: '%' },
        'draft',
        { key: 'draftPercentage', label: '%' },
        {
          key: 'menungguValidasiP3b',
          label: 'Menunggu Validasi P3B',
          class: 'text-center',
        },
        { key: 'menungguValidasiP3bPercentage', label: '%' },
        {
          key: 'dikembalikanP3b',
          label: 'Dikembalikan P3B',
          class: 'text-center',
        },
        { key: 'dikembalikanP3bPercentage', label: '%' },
        {
          key: 'selesaiInventarisasi',
          label: 'Selesai Inventarisasi',
          class: 'text-center',
        },
        { key: 'selesaiInventarisasiPercentage', label: '%' },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";

.card-body {
  position: relative;

  .pie-text {
    width: 105px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
}

.echarts {
  width: 100% !important;
}
</style>
